export const data = [
  {
    name: "New📣",
    href: "#news",
  },
  {
    name: "🍟🍔🥤BARAKALI Maxi BOX",
    href: "#boxs",
  },
  {
    name: "🥪Club - Sandvich",
    href: "#club",
  },
  {
    name: "🌯Lavash",
    href: "#lavash",
  },
  {
    name: "🌮Shawarma",
    href: "#shawarma",
  },
  {
    name: "🍔Burgers",
    href: "#burgers",
  },
  {
    name: "🍱Donar kebab",
    href: "#kebab",
  },
  {
    name: "🌭Hot-Dog",
    href: "#hot",
  },
  {
    name: "🍟Snacks",
    href: "#snacks",
  },
  {
    name: "🍚Garnish",
    href: "#garnish",
  },
  {
    name: "🍰Desserts",
    href: "#desserts",
  },
  {
    name: "🥤Drinks",
    href: "#drinks",
  },
];
